var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 20.7989 0 15.1984 2.17987 10.9202C4.09734 7.15695 7.15695 4.09734 10.9202 2.17987C15.1984 0 20.799 0 32 0H58C69.201 0 74.8016 0 79.0798 2.17987C82.843 4.09734 85.9027 7.15695 87.8201 10.9202C90 15.1984 90 20.799 90 32V58C90 69.201 90 74.8016 87.8201 79.0798C85.9027 82.843 82.843 85.9027 79.0798 87.8201C74.8016 90 69.201 90 58 90H32C20.7989 90 15.1984 90 10.9202 87.8201C7.15695 85.9027 4.09734 82.843 2.17987 79.0798C0 74.8016 0 69.201 0 58V32Z",
    fill: "url(#paint0_linear_2080_831)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 20.7989 0 15.1984 2.17987 10.9202C4.09734 7.15695 7.15695 4.09734 10.9202 2.17987C15.1984 0 20.799 0 32 0H58C69.201 0 74.8016 0 79.0798 2.17987C82.843 4.09734 85.9027 7.15695 87.8201 10.9202C90 15.1984 90 20.799 90 32V58C90 69.201 90 74.8016 87.8201 79.0798C85.9027 82.843 82.843 85.9027 79.0798 87.8201C74.8016 90 69.201 90 58 90H32C20.7989 90 15.1984 90 10.9202 87.8201C7.15695 85.9027 4.09734 82.843 2.17987 79.0798C0 74.8016 0 69.201 0 58V32Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4698 20.7178C30.4698 16.4554 27.0144 13.0001 22.7521 13.0001C18.4897 13.0001 15.0344 16.4554 15.0344 20.7178V31.2499C15.0344 44.611 25.8694 58.2779 44.9999 58.2779C63.1725 58.2779 74.9655 44.5999 74.9655 31.2499V20.7178C74.9655 16.4554 71.5101 13.0001 67.2478 13.0001C62.9854 13.0001 59.5301 16.4554 59.5301 20.7178V31.2499C59.5301 36.0404 54.6819 43.8426 44.9999 43.8426C35.318 43.8426 30.4698 36.0404 30.4698 31.2499V20.7178Z",
    fill: "#1B86F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4698 20.7178C30.4698 16.4554 27.0144 13.0001 22.7521 13.0001C18.4897 13.0001 15.0344 16.4554 15.0344 20.7178V31.2499C15.0344 44.611 25.8694 58.2779 44.9999 58.2779C63.1725 58.2779 74.9655 44.5999 74.9655 31.2499V20.7178C74.9655 16.4554 71.5101 13.0001 67.2478 13.0001C62.9854 13.0001 59.5301 16.4554 59.5301 20.7178V31.2499C59.5301 36.0404 54.6819 43.8426 44.9999 43.8426C35.318 43.8426 30.4698 36.0404 30.4698 31.2499V20.7178Z",
    fill: "url(#paint1_radial_2080_831)",
    fillOpacity: 0.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0345 24.1297V31.2499C15.0345 44.611 25.8694 59.2779 45 59.2779C63.1725 59.2779 74.9655 44.6 74.9655 31.2499V24.1392C72.5723 35.5939 61.6639 43.6948 45.4361 43.8373C45.2918 43.8408 45.1465 43.8426 45 43.8426C44.8531 43.8426 44.7073 43.8408 44.5626 43.8373C28.4141 43.6935 17.436 35.5885 15.0345 24.1297Z",
    fill: "url(#paint2_radial_2080_831)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2080_831",
    x1: 0,
    y1: 0,
    x2: 90,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F4F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2080_831",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45 20) rotate(-90.0001) scale(28.5 52.6526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2080_831",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.0001 51) rotate(-90) scale(71)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#94D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B86F2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.a4154fc093aa33a6a9d0d19a6528b1ad.svg";
export { ForwardRef as ReactComponent };